module.exports = __webpack_public_path__ + "media/images/banners/banner3-6031ff96798440cec41e6211e2f46e9d.jpg";